export const BLOCKED_DRAIN = 'BlockedDrain';
export const BROKEN_DRAIN_COVER = 'BrokenDrainCover';
export const BURST_WATER_MAIN = 'BurstWaterMain';
export const FLOODING = 'Flooding';
export const MISSING_DRAIN_COVER = 'MissingDrainCover';
export const SMELLY_DRAIN = 'SmellyDrain';
export const SOMETHING_ELSE = 'SomethingElse';
export const FOOTPATH = 'Footpath';
export const ROAD = 'Road';
export const FOOTPATH_LABEL = 'Pavement';
